import { ticketTimelineAnimate } from '~/directives/ticketTimelineAnimate';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('ticket-timeline-animate', ticketTimelineAnimate);
});
